import toBe from './toBe.json';
import Apostrofe from './Apostrofe.json';
import demonstrative from './demonstrative.json';
import frequency from './frequency.json';
import plurals from './plurals.json';
import PossessivePronouns from './possessive pronouns.json';
import presentsimple from './presentsimpleneg.json';
import simplepresent from './Simplepresent.json';
import time from './time.json';
import timePrep from './timeprep.json';
import toBeNeg from './toBeNeg.json';
import Possessive from './Possessives.json';
import articles from './articles.json';


// ✅ CORRECCIÓN: Usar el spread operator
export const GRAMMAR_M1 = [
  ...toBe, 
   ...Possessive, 
  ...Apostrofe, 
  ...demonstrative, 
  ...frequency, 
  ...plurals, 
  ...PossessivePronouns, 
  ...presentsimple, 
  ...time, 
  ...timePrep,
  ...toBeNeg, 
  ...simplepresent,
    ...articles, 
];